import { CSSProperties } from 'react';
import { Column } from '@tanstack/react-table';
import { Theme } from '@material-ui/core';

export const getCommonPinningStyles = (
  column: Column<any>,
  theme: Theme,
  isHeader?: boolean,
): CSSProperties => {
  const pinDirection = column.getIsPinned();

  return {
    ...(pinDirection === 'right'
      ? {
          borderLeft: `1px solid ${theme.palette.grey[300]}`,
          right: `${column.getAfter('right')}px`,
          textAlign: 'center',
        }
      : {}),
    ...(pinDirection === 'left'
      ? {
          borderRight: `1px solid ${theme.palette.grey[300]}`,
          left: `${column.getStart('left')}px`,
        }
      : {}),
    backgroundColor: theme.palette.white,
    position: 'sticky',
    zIndex: isHeader ? 4 : 3,
    padding: theme.spacing(0.5, 1),
  };
};
